import PastIntervalSelector from 'components/elements/PastIntervalSelect';
import WithLabel from 'components/elements/WithLabel';
import { useDateCreatedFilter } from 'state/filterDocuments';

const DateCreatedFilter = () => {
  const { dateCreatedFilter, setDateCreatedFilter } = useDateCreatedFilter();

  return (
    <WithLabel label="Date Created">
      <PastIntervalSelector value={dateCreatedFilter} onChange={setDateCreatedFilter} />
    </WithLabel>
  );
};

export default DateCreatedFilter;
